import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { db } from '../main.js'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    user: null,
    loading: null,
    error: null,
    projects: [],
    myProjects: []
  },
  mutations: {

    setUser(state, payload) {
      if (payload) {
        state.user = payload
        window.localStorage.setItem('user', payload.uid)
      } else {
        state.user = null
        window.localStorage.removeItem('user')
      }
    },
    removeUser(state) {
      state.user = null
      window.localStorage.removeItem('user')
    },
    addProject(state, payload) {
      let exist = state.projects.findIndex(item => item.id === payload.id)
      if (exist == -1) {
        state.projects.push(payload)
      }
    },
    addMyProject(state, payload) {
      let exist = state.myProjects.findIndex(item => item.id === payload.id)
      if (exist == -1) {
        state.myProjects.push(payload)
      }
    },
    removeMyProject(state, id) {
      console.log("id" + id)
      state.myProjects.splice(state.myProjects.findIndex(item => item.id === id), 1)
    },
    removeAllMyProject(state) {
      state.myProjects = null
      state.myProjects = []
    },
    removeProject(state) {
      state.projects = null
      state.projects = []
    },

    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    }

  },
  actions: {
    /**
     * User
     */
    async signUpAction({ commit }, payload) {
      
      commit('setError', null)
      commit('setLoading', true)
      
      await firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          commit('setUser', firebase.auth().currentUser)
          commit('setError', null)
        })
        .catch((error) => {
          commit('setError', error)
        })
        
      commit('setLoading', false)
    },

    async signInAction({ commit }, payload) {
      commit('setLoading', true)
      commit('setError', null)
      await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          commit('setUser', firebase.auth().currentUser)
          commit('setError', null)
        })
        .catch((error) => {
          commit('setError', error)
        })
      commit('setLoading', false)
    },

    async signOutAction({ commit }) {
      
      commit('setLoading', true)
      commit('setError', null)
      
      await firebase
        .auth()
        .signOut()
        .then(() => {
          commit('setUser', null)
          commit('setError', null)
        })
        .catch((error) => {
          commit('setError', error)
        })
      
      commit('setLoading', false)
    },
    async loadUser({ commit }) {
      let user = await firebase.auth().currentUser
      if (user) {
        commit('setUser', user)
      }
    },
    async removeMyAccount({commit}) {

      commit('setLoading', true)

      var user = await firebase.auth().currentUser

      if (user) {
        let myProjects = this.state.myProjects
        myProjects.forEach(project => {
          db.collection('project').doc(project.id).delete()
          commit('removeMyProject', project.id)
        })

        user.delete().then(function() {
          commit('removeUser')
        }).catch((error) => {
          console.log(error)
        });
      }

      commit('setLoading', false)
    },

    /**
     * MyProjects
     */
    async addMyProject({commit}, payload) {
      commit('setLoading', true)
      await db
        .collection("project").add({
          userUid: firebase.auth().currentUser.uid,
          title: payload.title,
          presentation: payload.presentation,
          email: payload.email,
          phone: payload.phone,
          need: payload.need,
          publied: payload.publied,
          timestamp: payload.timestamp,
          departement: payload.departement
        })
        .then(() => {
          return true
        })
        .catch((error) => {
          console.log(error);
        });
        commit('setLoading', false)
    },
    async updatePubliedProject(state, payload) {
      await db
        .collection('project')
        .doc(payload.id)
        .update({ 'publied': payload.publied })
    },
    async removeMyProject(state, payload) {
      await db
        .collection('project')
        .doc(payload.id)
        .delete()
        .then(() => {
          return true
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // Listener of MyProjects
    listenerMyProjects({ commit }) {
      // Sync CRUD MyProjects with firestore
      db.collection("project")
        .where("userUid", "==", firebase.auth().currentUser.uid)
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach(function (change) {
            if (change.type === "added") {
              commit('addMyProject', Object.assign({ id: change.doc.id }, change.doc.data()));
            }
            if (change.type === "modified") {
              console.log("Modified MyProjects: ", Object.assign({ uid: change.doc.id }, change.doc.data()))
            }
            if (change.type === "removed") {
              commit('removeMyProject', change.doc.id)
            }
          });
        });
    },
    /**
     * End MyProjects
     */

    /**
     * Get Projects search (visible on Home)
     */
    async search({ commit }, payload) {

      commit('setLoading', true)

      commit('removeProject')

      let query = await db
        .collection("project")
        .where("need", "==", payload.need)

      let result = await query
        .where("publied","==", true)
        .orderBy("timestamp", "desc")
        .get()

      for (let project of result.docs) {
        commit('addProject', Object.assign({ id: project.id }, project.data()))
      }

      commit('setLoading', false)

    }

    },

    getters: {

      loading(state) {
        return state.loading
      },
      user(state) {
        return state.user
      },
      error(state) {
        return state.error
      },
      projects(state) {
        return state.projects
      },
      myProjects(state) {
        return state.myProjects
      }
    }
  })